import React, {PureComponent} from 'react';
import {withTranslation} from "react-i18next";
import {connect} from "react-redux";
import {bindActionCreators} from "redux";
import {Col, Row} from "reactstrap";
import Chart from 'react-google-charts';
import DateRange from "./DateRange";

class EventTimelineChart extends  PureComponent{
  constructor(props) {
    super(props);

    this.state = {
      timelineStartRange: false,
      timelineEndRange: false,
    }
  }

  alterString = function(str) {
    return str.replace(/_/g,' ').toLowerCase()
      .replace(/^.|\s\S/g, function(a) {
        return a.toUpperCase();
      })
  };

  reArrangeTimeLineChartData = (assetsEvent, startDateRange, endDateRange) => {
    const newData = JSON.parse(JSON.stringify(assetsEvent));
    if(assetsEvent && assetsEvent.length > 0) {
      let filteredData = [
        [
          { type: 'string', id: 'Severity' },
          { type: 'string', id: 'Name' },
          { type: 'string', id: 'style', role: 'style' },
          {type: 'string', role: 'tooltip', 'p': {'html': true}},
          { type: 'date', id: 'Start' },
          { type: 'date', id: 'End' },
        ]
      ];

      newData.map( data => {
        let color =
          data.severity.toLowerCase() === "critical"
            ? '#e06874' : (
              (data.severity.toLowerCase() === 'major')
                ? '#fd8b73' : (
                  (data.severity.toLowerCase() === 'minor') ? '#f3c043' : '#5fc9af'
                )
            );

        const tooltipTime = `${new Date(data.first_seen).toLocaleString('en-US', { hour: 'numeric', hour12: true })} ${new Date(data.first_seen).toString().slice(0, 15)}`;
        const aiConf = this.alterString(data.last_ai_confidence);

        const badgeClass =
          (data.severity === 'MAJOR')
            ? 'color: #fd8b73; background: #ffe8e3': (
              (data.severity === 'MINOR')
                ? 'color: #f3c043; background: #fff7e4': (
                  (data.severity === 'NORMAL')
                    ? 'color: #5fc9af; background: #dff4ef': ('color: #e06874; background: #f9e1e3')
                )
            );
        const dotClass =
          aiConf && aiConf.toLowerCase() ==='low'
            ? 'red-circle' : 'green-circle';

        const toolTip = `<div>
                        <p><b>${this.alterString(data.event_type)}</b></p>
                        <p class="prediction-status">${this.alterString(data.event_label)}</p>
                        <hr/>
                        <p>
                            AI CONF.
                            <i class="tooltip-circle ${dotClass}"></i>
                            <span class="tooltip-conf">${aiConf}</span>
                        </p>
                        <p class="tooltip-time">${tooltipTime}</p>
                        <p>
                            SEVERITY
                            <mark style="${badgeClass}">${data.severity}</mark>
                        </p>
                    </div>`;

        if(startDateRange && endDateRange) {
          if(
            data.first_seen >= startDateRange &&
            data.last_seen <= endDateRange
          ) {
            filteredData.push([
              this.alterString(data.event_type),
              data.severity,
              color,
              toolTip,
              new Date(data.first_seen *1000),
              new Date(data.last_seen *1000),
            ]);
          }
        } else {
          filteredData.push([
            this.alterString(data.event_type),
            data.severity,
            color,
            toolTip,
            new Date(data.first_seen *1000),
            new Date(data.last_seen *1000),
          ]);
        }

        return data;
      });

      return filteredData;
    }
    return [];
  };

  timelineDateRangeChangeHandler = ({date_range}) => {
    this.setState({
      timelineStartRange:
        date_range.start &&
        date_range.start.getTime() / 1000,
      timelineEndRange:
        date_range.end &&
        date_range.end.getTime() / 1000
    });
  };

  render () {
    const { timelineStartRange, timelineEndRange } = this.state;
    const { timelineData, assetsEventLabel } = this.props;
    const selectedSource = [];

    const newEventsPredictionTimelineData =
      this.reArrangeTimeLineChartData(timelineData, timelineStartRange, timelineEndRange);

   return (
     <React.Fragment>
       <div className="date-range-container">
         <div className="col-lg-7 col-sm-7 col-xs-12">
           {selectedSource.map((item, itemIndex)=>
             <a href="#" className="btn-primary" key={itemIndex} >{item.name} <img src="img/close.png" alt=""/></a>
           )}
         </div>
         <div className="col-lg-5 text-right col-sm-5 col-xs-12">
           <DateRange
             name={'date_range'}
             onChange={this.timelineDateRangeChangeHandler}
             icon
             hasLabel
           />
         </div>
       </div>
       <Row>
         <Col md={12} className={'timeline-chart-container'}>
           {newEventsPredictionTimelineData &&
           newEventsPredictionTimelineData.length > 1 &&
           <Chart
             width={'calc(100% - 10px)'}
             height={'230px'}
             chartType="Timeline"
             loader={<div>Loading Chart</div>}
             data = { newEventsPredictionTimelineData }
             options={{
               timeline: {
                 showBarLabels: false,
                 rowLabelStyle: {
                   color: '#8392a5',
                   fontSize: 14,
                   fontWeight: 'normal',
                 },
                 barLabelStyle: {
                   color: '#8392a5',
                 },
               },
             }}

             rootProps={{ 'data-testid': '7' }}
           />
           }

           <div className={'text-center'}>Timeline</div>

         </Col>
       </Row>
     </React.Fragment>
   );
  }
}

EventTimelineChart.propTypes = {
};

function mapStateToProps({ eventManagement }) {
  return {
    assetsEventLabel: eventManagement.assetsEventLabel,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    { },
    dispatch
  );
}

export default withTranslation('common') (
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(EventTimelineChart)
);
